<template>
  <div class="opple-ability-ui-com-input">
    <el-input
      v-model="value"
      type="text"
      :disabled="item.Readonly"
      :maxlength="item.Max"
      class="ip_input"
    />
    <span class="opple-ability-ui-com-input_unit">{{ item.ParaUnit }}</span>
  </div>
</template>

<script>
import { NEIGHBOR_GROUP } from '@/utils/enums';

function isHexString(item) {
  return item.KeyId === 224;
}


export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      value: ''
    }
  },

  computed: {
   
  },

  mounted() {
    this.initValue();
  },

  methods: {
    initValue() {  
      const { DefaultValue } = this.item;

      try {
        if (isHexString(this.item)) {
          this.value = +DefaultValue - parseInt(NEIGHBOR_GROUP, 16);
          return;
        } else {
          this.value = DefaultValue;
        }
      } catch (error) {
        this.value = DefaultValue;
      }
    },

    getData() {
      const { item } = this;
      const { KeyId, ParaType } = item;
      let hasUIPrecision = !!item.UI && !!item.UI.Precision;
    
      if (isHexString(item)) {
        return {
          Key: item.KeyId,
          Values: [`${parseInt(NEIGHBOR_GROUP, 16) + this.value}`]
        }
      }

      if (hasUIPrecision) {
        const precision = item.UI.Precision.split('.')[1].split('').length * 10;
  
        return {
          Key: item.KeyId,
          Values: `${this.value * precision}`.split(',')
        }
      } else {
        return {
          Key: item.KeyId,
          Values: `${this.value}`.split(',')
        }
      }
    }
  },
};
</script>

<style lang="scss">
.opple-ability-ui-form {
  .opple-ability-ui-com-input {
    position: relative;
    display: flex;

    .ip_input {
      position: relative;
      right: auto;
    }

    &_unit {
      position: absolute;
      right: -30px;
    }
  }
}

</style>